<template>
  <Layout
    class="notFound"
    heading="404"
    sub-heading="お探しのページは見つかりませんでした"
  >
    <template #default>
      <Heading priority="4" class="notFound__description">
        URLが間違っているか、ページが存在しません。
      </Heading>
    </template>
    <template #symbolMark>
      <div
        class="notFound__symbolMark"
        :style="{
          backgroundImage: `url(${symbolMark})`
        }"
      />
    </template>
  </Layout>
</template>

<script>
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Layout from "../Molecules/Layout/index.vue";

export default {
  name: "ErrorNotFound",
  components: {
    Heading,
    Layout
  },
  data() {
    return {
      symbolMark: require("@/assets/images/Pages/Error/NotFound/symbolMark.svg")
    };
  }
};
</script>

<style scoped lang="scss">
.notFound {
  &__symbolMark {
    position: absolute;
    top: 51px;
    left: -36px;
    background-repeat: no-repeat;
    background-position: left top;
    background-size: cover;
    width: 100%;
    height: calc(100% - 51px);
  }
  &__description {
    color: $grayscale50;
  }
}
</style>
